import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App'
import { LanguageProvider } from './i18n/LanguageContext'

const container = document.getElementById('root')!

const tree = (
  <StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </StrictMode>
)

// Strony przechodzą prerender przy buildzie, więc w produkcji kontener ma już
// gotowy HTML — wtedy go hydratujemy zamiast renderować od zera. W trybie dev
// (i gdyby prerender kiedyś nie objął jakiegoś adresu) kontener jest pusty
// i wchodzi zwykły createRoot.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree)
} else {
  createRoot(container).render(tree)
}
